export default "__VITE_ASSET__YzE7hntL__"